import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useTheme} from '@mui/material/styles';

const ErrorText = ({children}) => {
  const theme = useTheme();
  return <div style={{
    color: theme.palette.error.main,
    fontSize: theme.typography.pxToRem(12.5),
    fontWeight: theme.typography.fontWeightSemiBold,
    marginTop: 6,
    display: 'flex',
    alignItems: 'center',
    gap: 5,
  }}>
    <svg width={13} height={13} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round'>
      <path d='M12 9v4' />
      <path d='M12 17h.01' />
      <path d='M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z' />
    </svg>
    {children || <FormattedMessage id='validation.required'/>}
  </div>;
};

export default ErrorText;
